import React, { Fragment } from 'react';

const Radio = ({ question, name, type, required = true, answers, onFieldChange }) => {
  return (
    <fieldset className="field">
      {question && <legend className="field__label">{question}</legend>}
      {answers.map(option => (
        <Fragment key={option.id}>
          <input
            id={`control-${option.id}`}
            name={name}
            type={type}
            value={option.id}
            required={required}
            onChange={e => onFieldChange(e.target, e.target.value)}
            className="field__hidden"
          />
          <label className="field__control" htmlFor={`control-${option.id}`}>
            {option.answer}
          </label>
        </Fragment>
      ))}
    </fieldset>
  );
};

export default Radio;
